<template>
  <el-dialog
    id="github"
    class="align-left"
    :visible.sync="visible"
    :append-to-body="appendToBody"
  >
    <el-button class="sync" size="mini" @click.prevent="refresh(true)">
      <i class="mdi mdi-github" />
      Synchronize your Github repositories
    </el-button>

    <el-table
      v-loading="loading"
      :data="data"
      :show-header="false"
      size="small"
    >
      <el-table-column prop="full_name" />

      <el-table-column width="100px">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.private" type="danger" size="small">
            <i class="el-icon-lock" /> Private
          </el-tag>
          <el-tag v-else type="secondary" size="small">Public</el-tag>
        </template>
      </el-table-column>

      <el-table-column width="120px" align="right">
        <template slot-scope="scope">
          <el-button
            v-if="true"
            type="primary"
            size="small"
            @click.prevent="connect(scope.row)"
          >
            Connect
          </el-button>

          <el-button
            v-else
            type="danger"
            size="small"
          >
            Unnlink
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
export default {
  props: {
    applicationId: String,
    open: Boolean,
    loading: Boolean,
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      visible: this.open,
      data: []
    }
  },
  mounted () {
    if (this.visible) {
      this.refresh()
    }
  },
  methods: {
    refresh (sync) {
      const params = {
        sync,
        applicationId: this.applicationId
      }

      this.$emit('update:loading', true)
      this.$store.dispatch('getGithubRepositories', params).then((data) => {
        this.data = data
        this.$emit('update:loading', false)
      }).catch(() => {})
    },
    connect (repo) {
      this.$emit('update:loading', true)
      this.$store.dispatch('connectRepository', {
        applicationId: this.applicationId,
        github: repo.id
      }).then(() => {
        this.visible = false
        this.$emit('change')
      }).catch(() => {})
    }
  },
  watch: {
    open (value) {
      this.visible = value
    },
    visible (value) {
      if (value) {
        this.refresh()
      }
      this.$nextTick(() => this.$emit('update:open', value))
    }
  }
}
</script>

<style lang="scss">
  #github {
    .el-dialog__body {
      padding-top: 0;
    }
  }
</style>

<style lang="scss" scoped>
  .el-button.sync {
    margin-bottom: 15px;
  }
</style>
